// extracted by mini-css-extract-plugin
export default {"Form":"SignUpForm_Form__s+vpG","FormElements":"SignUpForm_FormElements__lGI+U"};